import { REGEX } from '@/constants';

export const validateOTP = (otp) => {
  if (!otp.length) {
    return {
      valid: false,
      message: 'Enter the code we sent to your email.',
    };
  } else if (!REGEX.otp.test(otp)) {
    return {
      valid: false,
      message: 'Please enter a valid code.',
    };
  }

  return { valid: true };
};

export const validateEmail = (email) => {
  if (!email.length) {
    return {
      valid: false,
      message: 'Enter your email to continue.',
    };
  } else if (!REGEX.email.test(email)) {
    return {
      valid: false,
      message: 'Please enter a valid email.',
    };
  }

  return { valid: true };
};
